import React from 'react'

interface State {
  user?: any
  
}
const UserContext = React.createContext<State>({ user: undefined})
export default UserContext
